import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { MachineService } from '../proxy/general/controllers/machine.service';
import { MovilizationTypeService } from '../proxy/general/controllers/movilization-type.service';
import { MachineHeaderChangeHistoric } from '@general/machine-header-change-historic/machine-header-change-historic';

FieldBuilder.setNamespace('General');

export const HARVESTER_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .foreignKey('movilizationTypeId', 'Entity.MovilizationType', MovilizationTypeService)
    .required()
    .displayFromNested('movilizationType.name')
    .sortBy('movilizationType.name')
    .build(),
  FieldBuilder
    .foreignKey('machineId', 'Entity.Machine', MachineService)
    .required()
    .displayFromNested('machine.name')
    .sortBy('machine.name')
    .hideInChildForms()
    .build(),
];

export const HARVESTER_CONFIG = {
  entityName: 'Harvester',
  localizationKey: 'General::Entity.Harvester',
  fields: HARVESTER_FIELDS,
  permission: 'GeneralMachinesAndVehicles.Harvesters',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.General + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.MachinesAndVehicles + MENU_NAME_SUFFIX,
  children: [
      {
        entityName: 'MachineHeaderChangeHistoric',
        foreignKeyField: 'machineId',
        localizationKey: 'General::Entity.MachineHeaderChangeHistoric',
        component: MachineHeaderChangeHistoric,
      },
    ]
};
